const init = () => {
  const searchInputSpecialty = document.querySelector('[name="specialty-search"]');
  const searchInput = document.querySelector('[name="surgeon-search"]');

  // console.log('Init running');
  // console.log('Found specialty input:', searchInputSpecialty);
  // console.log('Found search input:', searchInput);

  if (searchInput) {
    searchInput.addEventListener('change', (event) => {
      // console.log('Selected state:', event.target.value);
      searchInputSpecialty.value = ''
      const value = event.target.value.toLowerCase();
      const items = document.querySelectorAll('[data-search]');

      // Debug what data we have
      items.forEach((item) => {
        // console.log('Item data-search:', item.dataset.search);
      });

      if (!value) {
        items.forEach((item) => {
          item.classList.remove('!hidden');
        });
        return;
      }

      items.forEach((item) => {
        const searchIn = item.dataset.search?.toLowerCase();
        // console.log('Comparing:', value, 'with:', searchIn);
        if (searchIn && searchIn.includes(value)) {
          item.classList.remove('!hidden');
        } else {
          item.classList.add('!hidden');
        }
      });
    });
  }


  if (searchInputSpecialty) {
    searchInputSpecialty.addEventListener('change', (event) => {
      // console.log('Specialty changed:', event.target.value);
      searchInput.value = ''
      const valueSpecialty = event.target.value.toLowerCase();
      const itemsSpecialty = document.querySelectorAll('[data-specialty]');

      // console.log('Found surgeon items:', itemsSpecialty.length);
      // console.log('First surgeon specialty:', itemsSpecialty[0]?.dataset.specialty);

      if (!valueSpecialty) {
        itemsSpecialty.forEach((spe) => {
          spe.classList.remove('!hidden');
        });
        return;
      }

      itemsSpecialty.forEach((spe) => {
        const searchInSpe = spe.dataset.specialty?.toLowerCase();
        // console.log(searchInSpe);
        const speArray = searchInSpe.split(', ');
        // console.log(speArray);
        if (searchInSpe && speArray.includes(valueSpecialty)) {
          spe.classList.remove('!hidden');
          // console.log(spe)
        } else {
          spe.classList.add('!hidden');
        }
      });
    });
  }
};

// Call init when the DOM is ready
document.addEventListener('DOMContentLoaded', init);

export default init;
